// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__1FwTo","inp":"Switch_inp__39SN7"};